import React from 'react'
import { Select, Spin } from 'antd'
import { CompanySearchItem } from '../../../../../services/api/companies'

const { Option } = Select

type Props = {
  selectedCompany: CompanySearchItem | undefined
  availableCompanies: CompanySearchItem[]
  isLoading: boolean
  isSearching: boolean
  handleSearch: (value: string) => void
  handleChange: (value: string) => void
}

export const View: React.FunctionComponent<Props> = ({
  selectedCompany,
  availableCompanies,
  isLoading,
  isSearching,
  handleSearch,
  handleChange,
}) => {
  const selectedInOptions: boolean = !!availableCompanies.find(
    (company) => selectedCompany?.id === company.id
  )

  if (isLoading) {
    return <Spin size="small" />
  }

  return (
    <Select
      showSearch
      allowClear
      value={selectedCompany?.id}
      style={{ width: '100%' }}
      size="large"
      placeholder="Выберите компанию"
      defaultActiveFirstOption={false}
      showArrow={false}
      filterOption={false}
      onSearch={handleSearch}
      onChange={handleChange}
      loading={isSearching}
      notFoundContent={isSearching ? <Spin size="small" /> : null}
    >
      {selectedCompany && !selectedInOptions && (
        <Option value={selectedCompany.id} key={selectedCompany.id}>
          {selectedCompany.name}
        </Option>
      )}
      {!isSearching &&
        availableCompanies.map((company) => (
          <Option value={company.id} key={company.id}>
            {company.name}
          </Option>
        ))}
    </Select>
  )
}
